/*
  Hydrate .meta-decks containers on the page with archetype appearances
  for the current product. Reads assets/featured-decks.json once per session.
*/
(() => {
  const containers = document.querySelectorAll('.meta-decks[data-product-handle]');
  if (!containers.length) return;

  const CACHE_KEY = 'inkwell:featured-decks:v1';
  const CACHE_TTL_MS = 1000 * 60 * 30; // 30 min

  async function loadDecks(url) {
    try {
      const cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        const parsed = JSON.parse(cached);
        if (parsed && Date.now() - parsed.t < CACHE_TTL_MS) return parsed.d;
      }
    } catch (_) { /* ignore */ }
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('featured-decks fetch failed');
    const data = await res.json();
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: data }));
    } catch (_) { /* quota, ignore */ }
    return data;
  }

  function findAppearances(decks, handle) {
    const out = [];
    (decks || []).forEach(deck => {
      const variants = [deck];
      if (deck.budget_deck) variants.push(deck.budget_deck);
      let matched = null;
      let qty = 0;
      for (const v of variants) {
        const cards = v.cards || [];
        for (const c of cards) {
          if (c && c.matched && c.handle === handle) {
            matched = deck;
            qty = Math.max(qty, c.qty || 1);
            break;
          }
        }
        if (matched) break;
      }
      if (matched) out.push({ deck: matched, qty });
    });
    return out;
  }

  (async () => {
    const first = containers[0];
    const url = first.getAttribute('data-decks-url');
    let decks;
    try {
      const data = await loadDecks(url);
      decks = Array.isArray(data) ? data : (data.decks || data.archetypes || []);
    } catch (e) {
      return;
    }

    containers.forEach(container => {
      const handle = container.getAttribute('data-product-handle');
      if (!handle) return;
      const hits = findAppearances(decks, handle).slice(0, 6);
      if (!hits.length) return;

      const list = container.querySelector('.meta-decks__list');
      if (!list) return;
      list.innerHTML = '';
      hits.forEach(({ deck, qty }) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.className = 'meta-decks__link';
        const slug = deck.slug || (deck.name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        a.href = '/pages/featured-decks' + (slug ? '#' + slug : '');
        a.setAttribute('data-deck-id', deck.id || '');
        const name = deck.name || 'Featured deck';
        const qtyHtml = qty ? '<span class="meta-decks__qty">' + qty + 'x</span>' : '';
        a.innerHTML = qtyHtml + ' ' + name.replace(/[<>&]/g, ch => ({ '<':'&lt;','>':'&gt;','&':'&amp;' })[ch]);
        li.appendChild(a);
        list.appendChild(li);
      });
      container.hidden = false;
    });
  })();
})();
